export default __webpack_public_path__ + "static/media/1189.f4c3956b.png";